"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const NotificationOff = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 12,
  height: 12,
  viewBox: "0 0 12 12"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  d: "M3.214 1.206A.375.375 0 0 0 2.65.714l-.646.74c-.366.42-.573.954-.585 1.512L1.39 4.325a.375.375 0 0 0 .75.015l.028-1.358c.008-.382.15-.748.4-1.035l.646-.74z",
  className: "fill"
}), /*#__PURE__*/_react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.118 3.85a2.107 2.107 0 0 1 2.103-1.975H5.5V1.5a.5.5 0 1 1 1 0v.375h.278A2.107 2.107 0 0 1 8.881 3.85l.111 1.767a3.7 3.7 0 0 0 .654 1.877.808.808 0 0 1-.568 1.264l-1.703.205V9.5a1.375 1.375 0 0 1-2.75 0v-.537l-1.704-.205a.808.808 0 0 1-.567-1.264 3.7 3.7 0 0 0 .654-1.877l.11-1.767zm2.103-1.225a1.357 1.357 0 0 0-1.354 1.272l-.11 1.767a4.45 4.45 0 0 1-.787 2.258.059.059 0 0 0 .041.092l1.868.224a9.438 9.438 0 0 0 2.241 0l1.869-.224a.059.059 0 0 0 .041-.092 4.45 4.45 0 0 1-.787-2.258l-.11-1.767a1.357 1.357 0 0 0-1.355-1.272H5.221zm.779 7.5a.625.625 0 0 1-.625-.625v-.375h1.25V9.5c0 .345-.28.625-.625.625z",
  className: "fill"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M8.822.678a.375.375 0 0 0-.036.529l.646.74c.25.287.392.653.4 1.035L9.86 4.34a.375.375 0 0 0 .75-.015l-.028-1.36a2.375 2.375 0 0 0-.585-1.511L9.35.714a.375.375 0 0 0-.53-.036z",
  className: "fill"
}));
var _default = exports.default = NotificationOff;